import { createSelector } from "reselect";

import { isAllSelected } from "./helpers";
import { dateToStartOfDay, dateToEndOfDay } from "../../utils/helpers";

const noDataTypeSelector = store => store.invoiceListStore.noDataType;

const totalCountSelector = store => store.invoiceListStore.total;

const orderSelector = store => store.invoiceListStore.order;

const paginationSelector = store => store.invoiceListStore.pagination;

const filtersSelector = store => store.invoiceListStore.filters;

const exactSearchSelector = store => store.invoiceListStore.filters?.exactSearch;

const invoicesSelector = store => store.invoiceListStore.invoices;

const selectedInvoicesSelector = store => store.invoiceListStore.selectedInvoices;

function constructInvoiceListRequest(order, pagination, filters, withPaging = true) {
  const request = {};

  const sort = `${order.columnKey},${order.direction}`;
  if (sort) {
    request.sort = sort;
  }

  const { criteria, exactSearch } = filters;
  if (criteria) {
    request.keyword = criteria;
  }
  if (exactSearch) {
    request.exactSearch = exactSearch;
  }

  const statusesList = filters.statusFilters.filter(filter => filter.isActive).map(f => f.key);
  if (statusesList && statusesList.length > 0) {
    request.statuses = statusesList;
  }

  const shared = filters.typeFilters.some(filter => filter.isActive && filter.key === "SHARED");
  if (shared) {
    request.shared = shared;
  }

  const warning = filters.typeFilters.some(filter => filter.isActive && filter.key === "WARNING");
  if (warning) {
    request.warning = warning;
  }

  const { from, to } = filters;

  if (from) {
    request.from = dateToStartOfDay(new Date(from));
  }

  if (to) {
    request.to = dateToEndOfDay(new Date(to));
  }

  if (withPaging) {
    request.page = pagination.activePage - 1;
    request.size = pagination.itemsCountPerPage;
  }

  return request;
}

const isFiltersAppliedSelector = createSelector(filtersSelector, filters => {
  const { from, to, statusFilters, typeFilters, criteria } = filters;

  return (
    !!(from || to || criteria || statusFilters.some(status => status.isActive)) ||
    typeFilters.some(type => type.isActive)
  );
});

const isAllSelectedSelector = store => {
  const { invoices, selectedInvoices } = store.invoiceListStore;

  return isAllSelected(invoices, selectedInvoices);
};

const searchInvoiceListRequestSelector = store => {
  const { filters, pagination, order } = store.invoiceListStore;

  return constructInvoiceListRequest(order, pagination, filters);
};

const searchInvoiceListRequestWithoutePagingSelector = store => {
  const { filters, pagination, order } = store.invoiceListStore;
  return constructInvoiceListRequest(order, pagination, filters, false);
};

export {
  isAllSelectedSelector,
  orderSelector,
  paginationSelector,
  filtersSelector,
  invoicesSelector,
  exactSearchSelector,
  selectedInvoicesSelector,
  totalCountSelector,
  searchInvoiceListRequestSelector,
  searchInvoiceListRequestWithoutePagingSelector,
  noDataTypeSelector,
  isFiltersAppliedSelector
};
